import { render } from "./SideBar.vue?vue&type=template&id=1e4285fa"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"
script.render = render

export default script